import SectionMessage from '@atlaskit/section-message';
import { Link } from '@atlassian/amkt-common';
import { ANALYTICS_SUBJECT_LINK } from '@atlassian/mpac-analytics';
import React from 'react';
export default function NoAppsView({
  partnerDetails,
  canManagePartnerDetails,
  onCreateAppClick
}) {
  return /*#__PURE__*/React.createElement(SectionMessage, {
    title: "No apps",
    appearance: "warning"
  }, /*#__PURE__*/React.createElement("p", null, partnerDetails.name, " does not have any apps yet.", ' ', !canManagePartnerDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    href: "/manage/apps/create",
    onClick: () => onCreateAppClick(ANALYTICS_SUBJECT_LINK)
  }, "Create an app"), ".")));
}